import { render, staticRenderFns } from "./NewLocations.vue?vue&type=template&id=48b32ba7&scoped=true&"
import script from "./NewLocations.vue?vue&type=script&lang=js&"
export * from "./NewLocations.vue?vue&type=script&lang=js&"
import style0 from "./NewLocations.vue?vue&type=style&index=0&id=48b32ba7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b32ba7",
  null
  
)

export default component.exports